const Constants = {
  expoConfig: {
    extra: {
      apiBaseUrl: '',
      wsBaseUrl: '',
    }
  }
};
export default Constants;
